import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import styled from "styled-components";
import { Button } from "../Button";

const StyledRentConfirmationModal = styled.dialog`
    width: 600px;
    height: 300px;
    background: #1C1C1C;
    border-radius: 32px;
    display: none;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 24px;
    border-width: 0px;

    &::backdrop {        
        background-color: #00000090;
    }
    
    &[open] {
        display: flex;
    }
    
    #title {
        font-family: Exo 2;
        font-weight: 400;
        font-size: 30px;
        line-height: 100%;
        color: #FFFFFF;
        text-align: center;
    }
    
    #description {
        font-family: Exo 2;
        font-weight: 300;
        font-size: 16px;
        line-height: 100%;
        color: #A6A6A6;
        text-align: center;
        margin-bottom: 20px;
    }

    #input-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        margin-bottom: 20px;

        label {
            font-family: Exo 2;
            font-weight: 400;
            font-size: 16px;
            color: #FFFFFF;
            margin-bottom: 8px;
        }

        input {
            width: 100px;
            padding: 5px;
            font-size: 16px;
            text-align: center;
            border-radius: 8px;
            border: 1px solid #A6A6A6;
            outline: none;
        }

        #total-price {
            margin-top: 10px;
            font-family: Exo 2;
            font-weight: 300;
            font-size: 18px;
            color: #38EF7D;
        }
    }

    #action-container {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        width: 100%;
    }
`;

const RentConfirmationModal = forwardRef(function RentConfirmationModal(
    { onConfirm, matchPrice },
    ref
) {
    const modalRef = useRef();
    const [numberOfMatches, setNumberOfMatches] = useState(1);
    const totalPrice = matchPrice * numberOfMatches;

    useImperativeHandle(ref, () => ({
        open: () => modalRef.current.showModal(),
        close: () => modalRef.current.close(),
    }));

    const handleNumberOfMatchesChange = (event) => {
        const value = parseInt(event.target.value, 10);
        if (!isNaN(value) && value > 0) {
            setNumberOfMatches(value);
        }
    };

    return (
        <StyledRentConfirmationModal ref={modalRef}>
            <p id="title">Confirm Rent</p>
            <p id="description">
                This item will start giving you rewards after every match, but it will still belong to the owner.
            </p>
            <div id="input-container">
                <label htmlFor="number-of-matches">Number of Matches</label>
                <input
                    id="number-of-matches"
                    type="number"
                    value={numberOfMatches}
                    onChange={handleNumberOfMatchesChange}
                    min={1}
                />
                <p id="total-price">Total Price: {totalPrice} QORBI</p>
            </div>
            <div id="action-container">
                <Button
                    label="Confirm"
                    onClick={() => {
                        onConfirm(numberOfMatches, totalPrice);
                        modalRef.current.close();
                    }}
                />
                <span style={{ width: 10, display: "inline-block" }} />
                <Button
                    transparent
                    label="Cancel"
                    onClick={() => modalRef.current.close()}
                />
            </div>
        </StyledRentConfirmationModal>
    );
});

export default RentConfirmationModal;
